import { render, staticRenderFns } from "./MyCards.vue?vue&type=template&id=69574142"
import script from "./MyCards.vue?vue&type=script&lang=js"
export * from "./MyCards.vue?vue&type=script&lang=js"
import style0 from "./MyCards.vue?vue&type=style&index=0&id=69574142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports